exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nli a[data-v-34613d40]{\n    list-style: none;\n    margin-left:3px;\n}\nimg[data-v-34613d40]{\n    width: 28px !important;\n    height: 28px !important;\n}\nul[data-v-34613d40]{\n    margin:0;\n}\na[data-v-34613d40]  {\n    font-family: Roboto;\n    text-decoration: underline;\n}\n\n", ""]);

// exports
